import { ProductData } from 'types/ProductData';

type ProductValidationProps = {
  product: ProductData;
  count: number;
};

type ValidationResult = {
  stock_count: number;
  stock_total: number;
  requires_auth: boolean;
};

export const validateProduct = ({
  product,
  count,
}: ProductValidationProps): ValidationResult => {
  let stock_count = count;
  let price = product.storage_stock_price || 0;
  let requires_auth = false;

  const storageLimitMin = Math.max(
    product.storage_limit_min ?? 1,
    product.step
  );

  if (product.subcategory?.customer_auth === 1) {
    requires_auth = true;
  }

  if (stock_count < storageLimitMin) {
    stock_count = storageLimitMin;
  }

  if (product.storage_limit_max && stock_count > product.storage_limit_max) {
    stock_count = product.storage_limit_max;
  }

  if (
    product.storage_stock_count &&
    stock_count > product.storage_stock_count
  ) {
    stock_count = product.storage_stock_count;
  }

  if (
    product.storage_limit_max &&
    product.storage_limit_max < storageLimitMin
  ) {
    count = 0;
  }

  if (
    product.storage_stock_count != null &&
    product.storage_stock_count < storageLimitMin
  ) {
    count = 0;
  }

  if (
    product.storage_stock_discount_price &&
    product.storage_stock_discount_price < price
  ) {
    price = product.storage_stock_discount_price;
  }

  if (
    product.storage_wholesale_limit &&
    product.storage_wholesale_price &&
    product.storage_wholesale_price < price &&
    count >= product.storage_wholesale_limit
  ) {
    price = product.storage_wholesale_price;
  }

  return {
    stock_count: stock_count,
    stock_total: parseFloat((stock_count * price).toFixed(2)),
    requires_auth: requires_auth,
  };
};
